import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import ErrorPopup from "../components/ErrorPopup";

const ToastContext = createContext({
  showToast: () => {},
  hideToast: () => {},
});

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({ message: "", type: "success" });

  const hideToast = useCallback(() => {
    setToast((t) => ({ ...t, message: "" }));
  }, []);

  const showToast = useCallback((message, type = "success") => {
    if (!message) return;
    setToast({ message, type });
  }, []);

  const value = useMemo(
    () => ({ showToast, hideToast }),
    [showToast, hideToast]
  );

  return (
    <ToastContext.Provider value={value}>
      {children}
      {toast.message ? (
        <ErrorPopup
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      ) : null}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return ctx;
}
